<template>

<b-card class="card-transaction" no-body  >
  <b-card-body >
        <b-row >
          <b-col >
              <b-form   inline class="justify-content-md-center">

                  <b-form-group  >
                    <label >Estabelecimento</label>
                    <b-form-select
          
                    class="mb-2 mr-sm-2 mb-sm-0 "
                        v-model="dados.estabelecimento"
                        :options="lista_estabelecimentos"
                        value-field="id"
                        text-field="name"
                      ></b-form-select>
                  </b-form-group>

                  <!-- <b-form-group>
                    <label >Documento</label>
                        <b-form-input
                        v-model="dados.documento"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          placeholder="CPF/CNPJ"
                        ></b-form-input>
                  </b-form-group> -->

                  <b-form-group  >
                    <label >Tipo</label>
                    <b-form-select
          
                        class="mb-2 mr-sm-2 mb-sm-0 "
                        v-model="dados.tipoData"
                        :options="tipoData"
                         value-field="tipoData"
                        text-field="text"
                      ></b-form-select>
                  </b-form-group>

                  <b-form-group>
                    <label >Data Inicial</label>
                        <b-form-input
                        v-model="dados.data_inicio"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          placeholder="00/00/0000"
                          type="date"
                        ></b-form-input>
                  </b-form-group>

                  <b-form-group>
                    <label >Data Final</label>
                        <b-form-input
                          v-model="dados.data_fim"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          placeholder="00/00/0000"
                          type="date"
                        ></b-form-input>
                  </b-form-group>

                  <b-form-group  >
                    <label >Status</label>
                    <b-form-select
          
                        class="mb-2 mr-sm-2 mb-sm-0 "
                        v-model="dados.status"
                        :options="listaStatus"
                         value-field="status"
                        text-field="text"
                      ></b-form-select>
                  </b-form-group>

                  <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                    <label >-------</label>

                        <div class="text-center">

                          <b-button variant="gradient-primary "
                          v-if="!spiner"
                          block
                              @click="buscarOrdens()"
                            >
                              Buscar
                          </b-button>
                      
                          <b-button
                          v-if="spiner"
                          block
                              variant="gradient-primary"
                              disabled
                              class="mr-1"
                            >
                              <b-spinner small />
                              Busc..
                          </b-button>
                          
                        </div>
                  </b-form-group>

                  <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                    <label >-------</label>

                        <div class="text-center">
                          <Excel></Excel>
                        </div>
                  </b-form-group>
                
              </b-form>
          </b-col>
          
        </b-row>
    <b-tabs>
      <b-row>
        <b-col>
          <!-- <CapturaFoto></CapturaFoto> -->
          <Estatisticas></Estatisticas>
        </b-col>
      </b-row>
    </b-tabs>
   
    <b-tabs   >
      <b-row class="">
        <b-col  >
          <ListaOrdem></ListaOrdem>
        </b-col>
      </b-row>
    </b-tabs>

  </b-card-body>
</b-card>

</template>

<script>
import { BCard, BCardText, BLink,BRow, BCol, BTabs, BCardBody, BForm,BFormGroup, BFormInput, BButton, BFormSelect, BSpinner } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ListaOrdem from './home/ListaOrdem'
import CapturaFoto from "./components/CapturaFoto.vue";
import Estatisticas from "./components/Estatisticas.vue";
import Excel from "./components/Excel.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    ListaOrdem,
    BTabs,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormSelect,
    BSpinner,
    CapturaFoto,
    Estatisticas,
    Excel,
    
},

  data() {
    return {
      listaStatus: [{status:null,text:""},{status:3,text:"Confirmado"},{status:1,text:"Processando"},{status:2,text:"Cancelado"},{status:4,text:"Reservado"}],
      // listaEstabelecimento: [{ id: null, text: '' },{text:"PEDRO JUAN CABALLERO",id:1},{text:"CIUDAD DEL ESTE LAGO",id:2},{text:"CIUDAD DEL ESTE KM 8",id:3}],
      dados: {estabelecimento:"",documento:"",data_inicio:"",data_fim:"",status:"",tipoData:""},
      tipoData: [{tipoData:"vencimento",text:"Vencimento"},{tipoData:"payedAt",text:"Pagamento"}],
      spiner:false,
      camm1:"",
      camm2:"",
      videoSelect:"",
      


    };
  },

  created() {
    this.$store.dispatch("estabelecimentos/all_estabelecimentos");
    navigator.mediaDevices.enumerateDevices().then(this.gotDevices).then(this.getStream).catch();
    console.log(navigator.mediaDevices.getSupportedConstraints())
    console.log(this.camm2)
  },
  computed: {
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
  
  },

  methods: {

    gotDevices(deviceInfos) {
                var c= 1;
                for (var i = 0; i !== deviceInfos.length; ++i) {
                    var deviceInfo = deviceInfos[i];
                    var option = document.createElement('option');
                    option.value = deviceInfo.deviceId;
                     if (deviceInfo.kind === 'videoinput') {

                         //console.log(deviceInfos[i].deviceId + ' | '+ c);
                         if(c == 1){
                             this.camm1 = deviceInfos[i].deviceId;
                         }
                         if(c == 2){
                             this.camm2 = deviceInfos[i].deviceId;
                         }                         
                          c++;

                    option.text = deviceInfo.label || 'camera ' +
                        (this.videoSelect.length + 1);
                    this.videoSelect.appendChild(option);
                    } else {
                    deviceInfo;
                    }
                }

            },

      getStream() {
            if (window.stream) {
                window.stream.getTracks().forEach(function(track) {
                track.stop();
                });
            }

            var constraints = {

                video: {
                deviceId: {exact: this.videoSelect.value}
                }
            };

            navigator.mediaDevices.getUserMedia(constraints).
                then(this.gotStream).catch(function(err) {
                        console.log(err)
                });
        },
    
  async  buscarOrdens(){
    this.spiner = true
       console.log(this.dados)
      await this.$store
        .dispatch("estabelecimentos/buscarOrdens", this.dados)
        .then((data) => {

          this.spiner = false
         
        })
        .catch((error) => {
          this.spiner = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },

  },
};
</script>


<style scoped>

</style>